import { render } from '@mairistem/module';
import { GlobalWorkerOptions } from 'pdfjs-dist';
import PDF_WORKER_MIN from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import * as React from 'react';
import AppSubvention from '@/src/AppSubvention';
import { initialize } from '@/src/sentry';
import '@mairistem/comptabilite/comptabilite.css';
import '@mairistem/finances-utils/finances-utils.css';
import '@mairistem/piecesjointes/piecesjointes.css';
import '@/src/index.css';
import 'react-toastify/dist/ReactToastify.css';

GlobalWorkerOptions.workerSrc = PDF_WORKER_MIN;

initialize();

render(<AppSubvention />);
